
import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, FormGroupDirective, NgForm, Validators } from '@angular/forms';
import { ErrorStateMatcher } from '@angular/material/core';
import { AuthenticationService, Site, Tenant, User } from '@empusa/empusa-core';
import { SiteService } from '../../../../client/site.service';

@Component({
  selector: 'empusa-microapp-fbs-tenant-select',
  templateUrl: './microapp-fbs-tenant-select.component.html',
  styleUrls: ['./microapp-fbs-tenant-select.component.css']
})
export class MicroappFbsTenantSelectComponent implements OnInit {

  @Output() selectedTenant: EventEmitter<Tenant> = new EventEmitter();

  theSite: Site;
  public tenantForm: FormGroup;
  // tenants = new FormControl();
  tenantsToSelect: Tenant[] = [];
  currentUser: User;

  constructor(private formBuilder: FormBuilder, private authservice: AuthenticationService, private siteService: SiteService,) {

    this.tenantForm = this.formBuilder.group({
      tenants: ['', Validators.required],
    });
  }

  ngOnInit(): void {
    this.theSite = this.authservice.getCurrentSite();
    this.authservice.loadCurrentUser().then(user => {
      this.currentUser = user;
      this.siteService.getSite(this.currentUser.sites[0].uid).subscribe(resp => {
        resp.tenants.forEach(element => {
          if (!element.is_site) {
            this.tenantsToSelect.push(element);
          }
        });
      });
      // this.tenantForm = this.formBuilder.group({
      //   tenants: ['', Validators.required],
      // });
      // this.selectedTenant.emit(this.theSite.tenants[0]);
    })
  }
  get f(): any { return this.tenantForm.controls; }

  tenantSelected() {
    const theTenant: Tenant = this.f.tenants.value;
    this.selectedTenant.emit(theTenant);
  }

}

// ** Error when invalid control is dirty, touched, or submitted. */
export class MyErrorStateMatcher implements ErrorStateMatcher {
  isErrorState(control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {
    const isSubmitted = form && form.submitted;
    return !!(control && control.invalid && (control.dirty || control.touched || isSubmitted));
  }
}
